/***** 购物车组件 *****/
export const QUERY_SHOPPING_CART = 'QUERY_SHOPPING_CART';  // 查询购物车商品列表
export const DELETE_CART_PRODUCT = 'DELETE_CART_PRODUCT';  // 删除购物车商品
export const CHANGE_PRODUCT_COUNT = 'CHANGE_PRODUCT_COUNT';// 改变商品数量
export const QUERY_ORDER_PRODUCT = 'QUERY_ORDER_PRODUCT';  // 查询订单商品列表
export const QUERY_ORDER_DETAIL = 'QUERY_ORDER_DETAIL';    // 查询订单详情
export const QUERY_ORDER_ADDRESS = 'QUERY_ORDER_ADDRESS';  // 查询用户订单地址
export const ADD_ORDER_ADDRESS = 'ADD_ORDER_ADDRESS';      // 新增地址
export const QUERY_DEFAULT_ADDRESS = 'QUERY_DEFAULT_ADDRESS'; // 获取默认地址
export const CHECK_COUPONS = 'CHECK_COUPONS';              // 校验优惠码
export const GET_PAYMENT = 'GET_PAYMENT';                  // 获取支付方式
export const GET_DELIVERY = 'GET_DELIVERY';                // 获取配送方式
export const COMMIT_ORDER = 'COMMIT_ORDER';                // 提交订单得到订单号
export const ADD_FAVORITE = 'ADD_FAVORITE';                // 添加收藏
export const QUERY_VIRTUAL_COIN = 'QUERY_VIRTUAL_COIN';    // 查询用户下载币
export const GET_RMB_COIN = 'GET_RMB_COIN';                // 下载币兑换人民币
export const CHANGE_ACTIVITY = 'CHANGE_ACTIVITY';          // 更换活动
export const QUERY_COUPONS = 'QUERY_COUPONS';              // 查询优惠券列表
export const API_CONFIG = 'API_CONFIG';
/***** END 购物车组件 *****/


// WEBPACK FOOTER //
// ./src/components/work/shoppingCart/common/interfaces.js